export default "__VITE_PUBLIC_ASSET__9e1cb47a__"